import React from "react";
import {
	useEffect,
	useState
}
from "react";

import {
	useAuth
}
from "../contextos/AuthContext";

import {
	doc,
	getDoc
}
from "firebase/firestore";

import {
	db
}
from "../firebase/firebaseConfig";
import {
	useNavigate
}
from "react-router-dom";
import {
	collection,
	getDocs
}
from "firebase/firestore";
import { signOut } from "firebase/auth";
import { auth } from "../firebase/firebaseConfig";

import Dashboard from "../componentes/dashboard/Dashboard";

import motorEvaluacion from "../funciones/motores/motorEvaluacion";

import motorYuta from "../funciones/motores/motorYuta";

import {

    updateDoc

}
from "firebase/firestore";

const HomeV2 = () => {

    const {
        usuario
    } = useAuth();

    const navigate =
	useNavigate();
    
    const [
        datosUsuario,
        setDatosUsuario
    ] = useState(null);

    const [
        progresoMeta,
        setProgresoMeta
    ] = useState(null);

    const [
        noticia,
        setNoticia
    ] = useState(null);

    const [
        carreras,
        setCarreras
    ] = useState([]);
    
    const [
        carreraSeleccionada,
        setCarreraSeleccionada
    ] = useState(null);

    const [
        evidencias,
        setEvidencias
    ] = useState([]);

    const [examenes, setExamenes] = useState([]);

    const [

        motorListo,
    
        setMotorListo
    
    ] = useState(false);

    const [
        temas,
        setTemas
    ] = useState([]);
    
    const [
        materiasTemas,
        setMateriasTemas
    ] = useState([]);

    const cerrarSesion = async()=>{

        await signOut(auth);
    
        navigate("/");
    
    };

    const cambiarPerfil = async(perfil)=>{

        await updateDoc(
    
            doc(
    
                db,
    
                "usuarios",
    
                usuario.uid
    
            ),
    
            {
    
                perfilActivo:perfil
    
            }
    
        );
    
        navigate(0);
    
    };

    const cambiarExamen = async(idExamen)=>{

        const examen = examenes.find(
            e => Number(e.ID) === Number(idExamen)
        );
    
        if(!examen){
            return;
        }
    
        await updateDoc(
    
            doc(
                db,
                "usuarios",
                usuario.uid
            ),
    
            {
    
                examenPrincipal: examen.ID,
    
                examenNombre: examen.Examen
    
            }
    
        );
    
        navigate(0);
    
    };

    useEffect(
        () => {
    
            const cargar =
                async () => {

                    await motorEvaluacion.inicializarMotor();
                    setMotorListo(true);
                    const ref =
                        doc(
                            db,
                            "usuarios",
                            usuario.uid
                        );
    
                    const snap =
                        await getDoc(
                            ref
                        );
    
                    if (
                        snap.exists()
                    ) {
    
                        setDatosUsuario(
                            snap.data()
                        );

                        const progresoTemasSnap = await getDocs(
                            collection(db, "progreso_temas")
                        );
                        
                        const evidenciasUsuario = [];

                        const examenesSnap = await getDocs(
                            collection(db, "examenes")
                        );
                        
                        setExamenes(
                            examenesSnap.docs.map(doc => ({
                                id: doc.id,
                                ...doc.data()
                            }))
                        );
                        
                        progresoTemasSnap.docs.forEach((documento) => {
                        
                            const dataTema = documento.data();
                        
                            if (dataTema.userId === usuario.uid) {
                        
                                evidenciasUsuario.push(
                                    ...(dataTema.evidencias || [])
                                );
                        
                            }
                        
                        });
                        
                        setEvidencias(evidenciasUsuario);

                        const data =
	snap.data();

    const carrerasSnap = await getDocs(
        collection(db, "carreras")
    );
    
    const listaCarreras = carrerasSnap.docs
        .map(doc => doc.data())
        .filter(c =>
            Number(c.ExamenID) ===
            Number(data.examenPrincipal)
        );
    
    setCarreras(listaCarreras);

    const temasSnap = await getDocs(
        collection(
            db,
            "tema_componente"
        )
    );
    
    setTemas(
    
        temasSnap.docs.map(doc => ({
    
            id: doc.id,
    
            ...doc.data()
    
        }))
    
    );
    
    const materiasTemasSnap = await getDocs(
    
        collection(
    
            db,
    
            "materias_temas"
    
        )
    
    );
    
    setMateriasTemas(
    
        materiasTemasSnap.docs.map(doc => ({
    
            id: doc.id,
    
            ...doc.data()
    
        }))
    
    );
    
    setCarreraSeleccionada(
        data.carreraObjetivo
    );

const examenCodigo = {

	1: "icfes",

	2: "unal",

	3: "udea"
};

const progresoId =
	`${usuario.uid}_${
		examenCodigo[
			data.examenPrincipal
		]
	}`;

const progresoRef =
	doc(
		db,
		"progreso_metas",
		progresoId
	);

const progresoSnap =
	await getDoc(
		progresoRef
	);

if (
	progresoSnap.exists()
) {

	setProgresoMeta(
		progresoSnap.data()
	);
    const noticiasSnap =
	await getDocs(
		collection(
			db,
			"noticias"
		)
	);

const noticias =
	noticiasSnap.docs

		.map(
			d => d.data()
		)

		.filter(
			n =>
				n.activo
		)

		.sort(
			(a, b) =>
				(
					a.prioridad || 999
				)
				-
				(
					b.prioridad || 999
				)
		);

if (
	noticias.length > 0
) {

	setNoticia(
		noticias[0]
	);
}

}
                    }
                };
    
            cargar();
    
        },
        [
            usuario
        ]
    );

    if (

        !motorListo ||
    
        !datosUsuario ||
    
        temas.length===0 ||
    
        materiasTemas.length===0
    
    ) {
    
        return null;
    
    }

    

    const examenNombre = {

        1: "ICFES",
    
        2: "UNAL",
    
        3: "UDEA"
    };

    const examenRuta = {

        1:
            "/quiz/Examen_Icfes",
    
        2:
            "/quiz/Examen_Unal",
    
        3:
            "/quiz/Examen_Udea"
    };

	const nodo =

    motorEvaluacion.crearNodoAcademico({

        tipo: "examen",

        id: "UNAL",

        hijos: []

    });

    console.log("================================");
console.log("TOTAL EVIDENCIAS:", evidencias.length);
console.log(evidencias);

const estadoAcademico =
motorEvaluacion.resolverEstadoAcademico({

    nodo,

    evidencias

});

	console.log(

		estadoAcademico
	
	);

    console.log("=== VARIABLES ===");

console.log(
    JSON.stringify(
        estadoAcademico.variables,
        null,
        2
    )
);

console.log("INDICE:", estadoAcademico.indice);

console.log(
    "PUNTAJE:",
    estadoAcademico.proyecciones.UNAL.puntaje
);

const carreraActual =
carreras.find(c =>
    Number(c.ID) ===
    Number(carreraSeleccionada)
);
const contextoYuta = {

    progreso: progresoMeta,

    carreras,

    componentes: [],

    temas,

    materiasTemas,

    curvas: [],

    examenes: [],

    metas: []

};

const yuta = motorYuta.crearMotorYuta({

    estadoAcademico,

    usuario: datosUsuario,

    objetivo: carreraActual,

    contexto: contextoYuta,

    nombreExamen: "UNAL",

    nombreObjetivo:

        carreraActual?.Carrera ??

        "Carrera"

});

const tutor = {

    ...yuta.dashboard,

    ...yuta.resumenSesion,

    carreraObjetivo:{

        ...yuta.dashboard.carreraObjetivo,

        nombre:
            carreraActual?.Carrera ??
            yuta.dashboard.carreraObjetivo.nombre,

        universidad:
            carreraActual?.Universidad ??
            yuta.dashboard.carreraObjetivo.universidad,

        ciudad:
            carreraActual?.Ciudad ??
            yuta.dashboard.carreraObjetivo.ciudad

    },

    puntajeObjetivo:

        carreraActual?.PuntajeCorte ??

        yuta.dashboard.puntajeObjetivo

};

const abrirGrupos = () => {

    if(datosUsuario?.perfilActivo === "profesor"){

        navigate("/profesor/grupos");

    }else{

        navigate("/grupos");

    }

};

	return (
		<Dashboard

    tutor={tutor}

    usuario={datosUsuario}

    progreso={progresoMeta}

    noticia={noticia}

    onEntrenar={()=>

        navigate(

            examenRuta[
                datosUsuario.examenPrincipal
            ]

        )

    }

    onPerfil={()=>

        navigate("/perfil")

    }

    carreras={carreras}

carreraSeleccionada={carreraSeleccionada}

onCambiarCarrera={setCarreraSeleccionada}

onCerrarSesion={cerrarSesion}

perfilActivo={
    datosUsuario?.perfilActivo
}

onCambiarPerfil={
    cambiarPerfil
}

examenes={examenes}

examenSeleccionado={
    datosUsuario.examenPrincipal
}

onCambiarExamen={
    cambiarExamen
}

onGrupos={abrirGrupos}

onMisMetas={() => navigate("/mis-metas")}

/>

	);
};



export default HomeV2;